module.exports = __webpack_public_path__ + "img/Standardwordverificationselect.a553b34b.svg";